import { breakpoints } from '@/styles/media';
import type { ComponentType, JSX } from 'react';
import styled from 'styled-components';

/** A flexible item that can adjust by breakpoint and whose children will fill it. */
export const FlexItem = styled.div<IFlexItemProps>`
    display: flex;
    align-items: stretch;
    > * {
        width: 100%;
    }
    ${({ $initial }: IFlexItemProps) => `width: ${($initial || 100).toString()}%`};
    ${({ $xs }: IFlexItemProps) => $xs && breakpoints.XS`width: ${$xs.toString()}%`};
    ${({ $s }: IFlexItemProps) => $s && breakpoints.S`width: ${$s.toString()}%`};
    ${({ $m }: IFlexItemProps) => $m && breakpoints.M`width: ${$m.toString()}%`};
    ${({ $l }: IFlexItemProps) => $l && breakpoints.L`width: ${$l.toString()}%`};
    ${({ $xl }: IFlexItemProps) => $xl && breakpoints.XL`width: ${$xl.toString()}%`};
    ${({ $xxl }: IFlexItemProps) => $xxl && breakpoints.XXL`width: ${$xxl.toString()}%`};
    ${({ $maximum }: IFlexItemProps) => $maximum && breakpoints.MAXIMUM`width: ${$maximum.toString()}%`};
`;

export interface IFlexItemProps {
    /**
     * Percentage width for initial size (0px+)
     * @default 100
     */
    $initial?: number;
    /**
     * Percentage width for breakpoint 'XS' and above
     */
    $xs?: number;
    /**
     * Percentage width for breakpoint 'S' and above
     */
    $s?: number;
    /**
     * Percentage width for breakpoint 'M' and above
     */
    $m?: number;
    /**
     * Percentage width for breakpoint 'L' and above
     */
    $l?: number;
    /**
     * Percentage width for breakpoint 'XL' and above
     */
    $xl?: number;
    /**
     * Percentage width for breakpoint 'XXL' and above
     */
    $xxl?: number;
    /**
     * Percentage width for breakpoint 'MAXIMUM' and above
     */
    $maximum?: number;
    /**
     * Override the HTML element
     * @default div
     */
    as?: keyof JSX.IntrinsicElements | ComponentType<any>;
}
